import type { FunctionComponent } from "react";

import { CardSectionContainer, CardSectionWord } from "./styles";

export type Props = {
  section: string;
};

export const StoryStyleCardSection: FunctionComponent<Props> = ({ section }) => (
  <CardSectionContainer>
    <CardSectionWord>{section}</CardSectionWord>
  </CardSectionContainer>
);

StoryStyleCardSection.displayName = "StoryStyleCardSection";
